import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { BASELINE } from "../../util/index";
import 'katex/dist/katex.min.css';
import Latex from "react-latex-next";

const DevQuestion = ({ stimulus, stem, a, b, c, d, correct_answer, rationale }) => {
    const boxItemLeftRef = useRef();

    useEffect(() => {
        const script2 = document.createElement('script');
        script2.src = "https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js";
        script2.integrity = "sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05";
        script2.crossOrigin = "anonymous";
        script2.defer = true;

        // Handle script load
        script2.onload = () => {
            if (boxItemLeftRef.current) {
                if (window.renderMathInElement) {
                    const boxItemLeft = document.getElementById("box-item-left");
                    window.renderMathInElement(boxItemLeft, {
                        delimiters: [
                            { left: '$$', right: '$$', display: false },
                            { left: "$", right: "$", display: false },
                            { left: '\\(', right: '\\)', display: false },
                            { left: '\\[', right: '\\]', display: true },
                            { left: '\\begin{array}', right: '\\end{array}', display: true }
                        ],
                        throwOnError: false,
                    });
                }
            }
        };
        document.body.appendChild(script2);

        // Cleanup: remove the script when component unmounts
        return () => {
            document.body.removeChild(script2);
        };
    }, [stimulus, stem, a, b, c, d, correct_answer, rationale]);

    return (
        <>
            <div id="box-item-left" ref={boxItemLeftRef}>
                <div className="flex">
                    <div className="w-[50%]">
                        <div className="ml-[20px]" dangerouslySetInnerHTML={{ __html: stimulus }} />

                        <div className="mt-[40px] ml-[20px]" dangerouslySetInnerHTML={{ __html: stem }} />

                    </div>
                    <div className="w-[50%]">
                        <Option idx={0} data={a} />
                        <Option idx={1} data={b} />
                        <Option idx={2} data={c} />
                        <Option idx={3} data={d} />
                    </div>
                </div>
                <div>
                </div>
            </div>
        </>
    )
}
export default DevQuestion;


const Option = ({ idx, data }) => {
    return (
        <div className="flex flex-row gap-1">
            <motion.div whileTap={{ scale: 0.98 }} className={`flex flex-row w-full border-[1px] rounded-md border-black gap-2 p-1 m-3 cursor-pointer relative`}>
                <div className="flex flex-row items-center">
                    <p className="flex flex-row items-center justify-center p-1 w-6 h-6 border-[1px] border-black rounded-full">
                        {getOptionLetter(idx)}
                    </p>
                </div>
                <div className="flex flex-row items-center p-[2px]" dangerouslySetInnerHTML={{ __html: data }}>
                </div>
            </motion.div>
        </div>
    )
}

function getOptionLetter(idx) {
    switch (idx) {
        case 0:
            return 'A'
            break;
        case 1:
            return 'B'
            break;
        case 2:
            return 'C'
            break;
        case 3:
            return 'D'
            break;
        default:
            return "A"
    }
}